"use strict";

var _classCallCheck = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var react_apollo_1 = require("react-apollo");

var graphql_tag_1 = __importDefault(require("graphql-tag"));

var utils_1 = require("@8base/utils");

var permissions_provider_1 = require("@8base-react/permissions-provider");

var createRecordTag = function createRecordTag(tableSchema, mode, options) {
  switch (mode) {
    case 'create':
      return utils_1.createTableRowCreateTag([tableSchema], tableSchema.id, options);

    case 'createMany':
      return utils_1.createTableRowCreateManyTag([tableSchema], tableSchema.id);

    case 'update':
      return utils_1.createTableRowUpdateTag([tableSchema], tableSchema.id, options);

    case 'delete':
      return utils_1.createTableRowDeleteTag([tableSchema], tableSchema.id);

    default:
      return '';
  }
};

var RecordCrud =
/*#__PURE__*/
function (_react_1$Component) {
  _inherits(RecordCrud, _react_1$Component);

  function RecordCrud() {
    _classCallCheck(this, RecordCrud);

    return _possibleConstructorReturn(this, _getPrototypeOf(RecordCrud).apply(this, arguments));
  }

  _createClass(RecordCrud, [{
    key: "render",
    value: function render() {
      var _a = this.props,
          tableSchema = _a.tableSchema,
          children = _a.children,
          mode = _a.mode,
          includeColumns = _a.includeColumns,
          rest = __rest(_a, ["tableSchema", "children", "mode", "includeColumns"]);

      var mutation = graphql_tag_1.default(createRecordTag(tableSchema, mode, {
        permissions: this.context.permissions,
        includeColumns: includeColumns || null
      }));
      return react_1.default.createElement(react_apollo_1.Mutation, Object.assign({}, rest, {
        mutation: mutation
      }), function (mutateFunction, mutateResult) {
        return children(mutateFunction, mutateResult);
      });
    }
  }]);

  return RecordCrud;
}(react_1.Component);

exports.RecordCrud = RecordCrud;
RecordCrud.contextType = permissions_provider_1.PermissionsContext;